import { VideoProject } from "@/services/bedrock";
import {
  VIDEO_PROJECT_STATUS_COLUMNS,
  VideoProjectStatusColumnDef,
  VideoProjectStatusColumnId,
  getRepresentativeStatusForColumn,
  getStatusColumnId,
  visibleStatusColumns,
} from "@/components/VideoProjectStatusPicker/columns";

export type KanbanColumnId = VideoProjectStatusColumnId;
export type KanbanColumnDef = VideoProjectStatusColumnDef;

export const KANBAN_COLUMNS: KanbanColumnDef[] = VIDEO_PROJECT_STATUS_COLUMNS;
export const getKanbanColumnId = getStatusColumnId;
export { getRepresentativeStatusForColumn };
export const visibleKanbanColumns = visibleStatusColumns;

export function isKanbanCardDraggable(status: VideoProject.Status): boolean {
  return status !== VideoProject.Status.POSTED && status !== VideoProject.Status.POST_FAILED;
}

export function showKanbanPriorityAccent(status: VideoProject.Status, isPriority?: boolean): boolean {
  return Boolean(isPriority) && getKanbanColumnId(status) !== "completed";
}
